import SiteSettings from 'src/siteSetting';
import { WORKLET_API_AUTH_TOKEN } from 'src/constants';

export const eventPromiseRequest = (data:any) => {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', `${SiteSettings.generalWorkletApi()}/realtime_event/?trigger_type=RequestResponse`);
      xhr.setRequestHeader('Authorization',`Token ${WORKLET_API_AUTH_TOKEN}`);
      xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
      xhr.setRequestHeader("Access-Control-Allow-Methods", "GET,HEAD,OPTIONS,POST,PUT");
      xhr.setRequestHeader("Access-Control-Allow-Headers", "*");
      xhr.setRequestHeader("content-type", "application/json");
      xhr.onload = function () {
        try {
          this.status >= 200 && this.status < 300
            ? resolve(JSON.parse(xhr.response))
            : reject([this.status, this.statusText]);
        } catch (e) {
          reject();
          //reportException(`<---Real time event Failure---> ${e}`)
        }
      };
      xhr.onerror = function () {
        reject([this.status, this.statusText]);
      };
      xhr.send(JSON.stringify(data))
    });
  }